import { executeRequest, Request } from '@jfs/network'
import { RootStore, useStores } from '../../data/store'
import { combineFirstAndLastName, getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'
const PRODUCT_ID = '1012222303009777000'
const TYPE = 'Savings'
const beneficiaryType = 'DMR'
const useLazyApiData = (apiFn) => {
  const { merchant } = useStores((root) => ({
    merchant: RootStore?.agent?.agentInfo?.agentUserLoginId,
  }))
}
const parsedDataBody = (body: any) => {
  return {
    remitterId: body?.remittanceUserId,
    productId: PRODUCT_ID,
    accountNumber: body?.beneficiaryAccountNumber,
    accountHolderName: body?.accountHolderName,
    nickName: combineFirstAndLastName(body?.beneficiaryFirstName ?? '', body?.beneficiaryLastName ?? ''),
    accountType: TYPE?.toUpperCase(),
    ifscCode: body?.ifscCode,
    mobileNumber: {
      countryCode: '91',
      number: body?.mobile,
    },
    beneficiaryType: beneficiaryType,
    createdBy: RootStore?.agent?.session?.CHANNEL_ID,
    createdFromChannel: RootStore?.agent?.session?.CHANNEL_ID,
    field5: 'B93,B94',
  }
}
const responseParser = (data: any) => {
  if (data?.data?.status === 'F') {
    throw {
      code: data.data.errorCode,
      message: data.data.errorMessage,
    }
  }
  if (isStatusOK(data)) {
    const agentStatus = data?.data?.responseObj?.agent?.agentStatus
    if (agentStatus) {
      return agentStatus
    }
    return data?.data?.responseObj
  } else {
    throw getNetworkResponseError(data?.data)
  }
}
export const checkWhetherTheAgentExistsApi = (tokens: any, body: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  const merchantId = RootStore.user?.selectedMid
  console.log(merchantId)
  const requestBody = {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      orderType: 'BUY',
      description: 'This is for the buy case.',
    },
    initiatingEntity: {
      entityId: RootStore.agent.session.CHANNEL_ID || '3155',
      channelId: RootStore.agent.session.CHANNEL_ID || '3155',
    },
    agent: {
      merchantId: RootStore?.agent?.agentInfo?.agentUserLoginId,
    },
  }

  // const requestBody = {

  //   merchantId: RootStore?.agent?.agentInfo?.agentUserLoginId,
  //   channelId: RootStore.agent.session.CHANNEL_ID || '3155',
  // }

  const request: Request<{}> = {
    apiPath: APIEndPoints.searchAgentBC,
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      console.log(data, 'Akanksha see what data we are sending to respponse parse')
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
